module.exports = __webpack_public_path__ + "img/19ne.283fce75.svg";